<div class="main">
  <div *ngIf="showLoader" class="loader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
  </div>

  <div class="section">
      <div class="header">
          <div class="title">
              <div class="label">
                  {{'unit.title' | translate}}
              </div>
              <div class="help">
              <app-help [helpData]="helpData" ></app-help>
              </div>
          </div>
          <div class="head">{{carrier_unit}}<br/>
              <span class="isc-code">
              ({{'unit.isc_code' | translate}} : {{isc_code}})
              </span>
          </div>
      </div>
      <div class="settings">
          <div class="card">
              <div class="header">
              {{'unit.shipmentId' | translate}}
              </div>
              <div class="content">
              <div class="inputSection">
                  <div class="label">
                  {{'unit.prefix' | translate}}
                  </div>
                  <input [disabled]="disablePrefix" [ngClass]="{disable: disablePrefix, none: !disablePrefix}" type="text" [(ngModel)]="sinCode.SIN_code">
              </div>
              <div class="inputSection">
                  <div class="label">
                  {{'unit.counter' | translate}}
                  </div>
                  <input [disabled]="disableCounter" [ngClass]="{disable: disableCounter, none: !disableCounter}" type="number" [(ngModel)]="counter.counter">
              </div>
              </div>
          </div>
          <div class="card">
              <div class="header">
                  {{'unit.support' | translate}}
                  </div>
              <div class="content-email">
                <div class="inputSection">
                  <div class="label">
                      {{'unit.email' | translate}}
                  </div>
                  <input type="text" [(ngModel)]="email.support_email">
                  <div class="helpText">
                    {{'unit.seperatedByCommas' | translate}}
                  </div>
                </div>
                <div class="submitButton" (click)="submitEmail();" >
                  <div class="button">
                    {{'unit.submit' | translate}}
                  </div>
                </div>
              </div>
              <div class="content-email">
                  <div class="inputSection">
                    <div class="label">
                        {{'unit.mobile' | translate}}
                    </div>
                    <input type="text" [(ngModel)]="mobile.support_no">
                  </div>
                  <div class="submitButton" (click)="submitMobile();" >
                    <div class="button">
                      {{'unit.submit' | translate}}
                    </div>
                  </div>
                </div>
          </div>

          <div class="card">
              <div class="content-logo">
                <div class="inputSection">
                  <div class="label">
                    {{'unit.logo' | translate}}
                  </div>
                  <input class="form-input" style="margin:0px" id="containerNo" accept="image/*, .pdf" (change)="fileChanged($event)" type="file" />
                </div>
                <div class="preview" *ngIf="logo">
                  <img src="{{logo}}" height="190" width="150">
                </div>
              </div>
            </div>
          <div class="card">
              <div class="header">
                  {{'accountSettings.waybillSettings' | translate}}
              </div>
              <div class="content-lr">
                <div class="default" *ngIf="!waybillSequence.custom_CWB_enabled">
                  <div class="label-d">
                    {{'accountSettings.defaultFormat' | translate}}
                  </div>
                  <div class="inputSection">
                    <div class="label">
                      {{'accountSettings.waybill' | translate}}
                    </div>
                    <input type="text" [disabled]="true" [(ngModel)]="lrSeq.lr_seq">
                  </div>
                </div>
                <div class="custom" [ngClass]="{'custom':!waybillSequence.custom_CWB_enabled ,'custom_en':waybillSequence.custom_CWB_enabled }">
                  <div class="label-c">
                    {{'accountSettings.customFormat' | translate}}
                  </div>
                  <div class="inputSection">
                    <div class="label">
                      {{'accountSettings.from' | translate}}
                    </div>
                    <input type="number" [(ngModel)]="waybillSequence.custom_range.from">
                  </div>
                  <div class="inputSection">
                    <div class="label">
                      {{'accountSettings.to' | translate}}
                    </div>
                    <input type="number" [(ngModel)]="waybillSequence.custom_range.to">
                  </div>
                  <div class="inputSection">
                    <div class="label">
                      {{'accountSettings.customText' | translate}}
                    </div>
                    <input type="text" [(ngModel)]="waybillSequence.custom_text">
                  </div>
                  <div class="submitButton" (click)="updateWaybillSeq();" >
                    <div class="button">
                      {{'unit.submit' | translate}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div>
                <div class="header" style="padding: 10px 0 0 0">
                  {{'unit.gps_providers' | translate}}
                </div>
                <div class="content-email" style="padding: 5px 10px 5px 10px">
                  <div class="inputSection">
                    <div class="label">
                      {{'unit.own_fleet' | translate}}
                    </div>
                    <mat-select multiple class="inputSelect"  [(ngModel)]="selectedOwnGPS" >
                      <mat-option *ngFor="let provider of own_gps_list" [value]="provider" >
                          {{provider}}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="submitButton" (click)="updateOwnFleetGPSProviders();" >
                    <div class="button">
                      {{'unit.submit' | translate}}
                    </div>
                  </div>
                </div>
                <div class="content-email">
                  <div class="inputSection">
                    <div class="label">
                      {{'unit.spot_drivers' | translate}}
                    </div>
                    <mat-select multiple class="inputSelect"  [(ngModel)]="selectedSpotGPS" >
                      <mat-option *ngFor="let provider of spot_gps_list" [value]="provider" >
                          {{provider}}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="submitButton" >
                    <div class="button" (click)="updateSpotGPSProviders();">
                      {{'unit.submit' | translate}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="header">
                  {{'unit.idle_time' | translate}}
              </div>
              <div class="content-email">
                <div class="inputSection" style="width: 68%;">
                  <div class="label">
                      {{'unit.current_idle_time' | translate}}: {{this.idleTimer}} {{'unit.mins' | translate}}
                  </div>
                  30 Mins <mat-slider
                  class="example-margin"
                  [max]="90"
                  [min]="30"
                  [step]="1"
                  [thumbLabel]="true"
                  (change)="changeIdleTimer()"
                  [tickInterval]="getSliderTickInterval()"
                  [(ngModel)]="idleTimer">
                  </mat-slider> 90 Mins
                </div>
              </div>
          </div>
          <div class="card">
            <div class="header">
              {{ "unit.vehicle_types" | translate }}
            </div>
            <div class="content-email">
              <div class="inputSection">
                <div class="label">
                  <mat-checkbox [(ngModel)]="checked">{{
                    "unit.changeVehicleType" | translate
                  }}</mat-checkbox>
                </div>
                <div class="label">
                  {{ "unit.vehicle_types" | translate }}
                </div>
                <div class="inputSelect">
                  <mat-select
                    multiple
                    [disabled]="!checked"
                    (close)="searchInput = ''; handleSearchFilter()"
                  >

                    <mat-select-trigger *ngFor="let vehicle of selectedVehicleNames">
                      {{ vehicle }}
                    </mat-select-trigger>
                    <div style="position: relative">
                      <div
                        style="
                          position: sticky;
                          top: 0;
                          z-index: 999;
                          background-color: white;
                          display: flex;
                          align-items: center;
                          padding: 8px;
                          border-bottom: 1px solid gray;
                          margin-left: 10px;
                          margin-right: 16px;
                        "
                      >
                        <input
                          style="
                            outline: none;
                            height: 24px;
                            padding: 2px;
                            padding-left: 4px;
                            width: 400px;
                            border: solid 1px #e3e3e3;
                            background: white;
                            border-radius: 4px;
                          "
                          placeholder="Search"
                          [(ngModel)]="searchInput"
                          (keyup)="handleSearchFilter()"
                          (keydown.space)="$event.stopPropagation()"
                        />
                        <div
                          style="
                            position: relative;
                            right: 28px;
                            display: flex;
                            align-items: center;
                            padding: 6px 0;
                          "
                        >
                          <img src="assets/search_icon_new.svg" alt="" />
                        </div>
                      </div>
                      <ng-container *ngFor="let vehicle of filteredVehicles">
                        <mat-option
                          (onSelectionChange)="selectvehicle($event, vehicle)"
                          [value]="{
                            _id: vehicle._id,
                            name: vehicle.name
                          }"
                        >
                          {{ vehicle.name }}
                        </mat-option>
                      </ng-container>
                    </div>
                  </mat-select>
                </div>
              </div>
              <div
                class="submitButton"
                (click)="submitVehicleTypes()"
                style="margin-top: 59px"
              >
                <div class="button">
                  {{ "unit.submit" | translate }}
                </div>
              </div>
            </div>
            <div class="selectedVehicle">
              <div class="label" style="font-weight: 600">
                Selected Vehicle Types
              </div>
              <div class="selectedVehicleList">
                <div class="vehicle" *ngFor="let vehicle of selectedVehicleNames">
                  <div class="vehicleName" style="padding: 8px">
                    {{ vehicle }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="card">
            <div>
              <div class="header">
                {{'unit.driver_holidays' | translate}}<br/>
                <i class="material-icons" title="Add Holiday" style="color:#ec1e54; cursor:pointer" (click)='addHolidays()'>add</i>
              </div>
              <div>
                <span class="sub-title">
                  ({{'unit.for_all_drivers' | translate}})
                </span>
              </div>
              <div class="content-holiday">
                <div class="table">
                  <table mat-table *ngIf="holidaysList.length; else noData" [dataSource]="holidaysList">
    
                    <ng-container matColumnDef="slno">
                      <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                        {{'HOLIDAYS_LIST.slno' | translate}}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{element.index}}
                      </td>
                    </ng-container>
    
                    <ng-container matColumnDef="holiday">
                      <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                        {{'HOLIDAYS_LIST.holiday' | translate}}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{element.holiday}}
                      </td>
                    </ng-container>
    
                    <ng-container matColumnDef="date">
                      <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                        {{'HOLIDAYS_LIST.date' | translate}}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{element.date}}
                      </td>
                    </ng-container>
    
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef style="padding-left: 3px;" >
                        {{'HOLIDAYS_LIST.action' | translate}}
                      </th>
                      <td mat-cell *matCellDef="let element">
                       <i class="material-icons" title="Edit Holiday" style="color:#104bb3; cursor:pointer" (click)='editHoliday(element)'>create</i>
                       <i class="material-icons" title="Delete Holiday" style="color:#ec1e54; cursor:pointer" (click)='deleteHoliday(element);$event.stopPropagation()'>delete</i>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayColumns;sticky:true;"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                  </table>
                  <ng-template #noData>
                    <div class="noData">
                      {{'HOLIDAYS_LIST.noData' | translate}}
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        
      </div>
  </div>

</div>
<!-- <ng-template #confirmDialog>
  <div class="confirmDialog" style="height: 150px;width: 600px;">
      <div class="head" style="text-align: center;height: 40px;background-color: #631d4f;color: #fff;">
          <span style="position: relative;top: 9px;font-size: 18px;"> {{'unit.alert' | translate}} </span>
      </div>
      <div class="body" style="padding: 10px;text-align: center;font-size: 20px;">
          <div class="text">
              {{'unit.message' | translate}}
          </div>
      </div>
      <div class="submitButton" style="text-align: center;background-color: green; width: 80px;height: 30px;border-radius: 4px;margin-left: 260px;margin-top: 15px;" (click)="success = true; closeDialog();">
          <div class="button" style="color: #fff; padding-top: 5px;" >
              {{'unit.ok' | translate}}
          </div>
        </div>
  </div>
</ng-template> -->
<!-- <ng-template #logoPreviewDialog>
  <div class="logoPreviewDialog">
    <div class="header">
      {{'unit.logo_preview' | translate}}
     <i class="material-icons" (click)='logoPreviewDialogRef.close()'>clear</i>
    </div>
    <div class="section">
      <div class="container">
        <img src="{{logo}}">
      </div>
    </div>
  </div>
</ng-template>



<div class="left">
  <div class="leftTop" *ngIf="sinCode.SIN_code || counter.counter">
      <div class="head">
          <div class="text">
              {{'unit.shipmentId' | translate}}
          </div>
      </div>
          <div class="container">
              <div class="inputBox" *ngIf="sinCode.SIN_code">
                  <div class="label">
                      {{'unit.prefix' | translate}}
                  </div>
                  <div class="inputForm">
                      <input disabled class="input" type="text" [(ngModel)]="sinCode.SIN_code">
                      
                  </div>
              </div>
               <div class="submitButton" (click)="submitPrefix();">
                  <div class="button" [ngStyle]="{'background-color':disablePrefix ? '#7d7d7d':'#e54131'}">
                    {{'unit.submit' | translate}}
                  </div>
                </div> -->
              <!-- <div class="inputBox" *ngIf="counter.counter" >
                  <div class="label">
                      {{'unit.counter' | translate}}
                  </div>
                  <div class="inputForm">
                      <input disabled class="input" type="text" [(ngModel)]="counter.counter">
                      
                  </div>
              </div> -->
              <!-- <div class="submitButton" (click)="submitCounter();">
                  <div class="button" [ngStyle]="{'background-color':disableCounter ? '#7d7d7d':'#e54131'}" >
                    {{'unit.submit' | translate}}
                  </div>
                </div> -->
              <!-- <div class="inputBox">
                  <div class="label">
                      Mobile
                  </div>
                  <div class="input">
                      <input class="input" type="text" placeholder="">
                  </div>
              </div> -->
          <!-- </div>
      
  </div>
  <div class="leftBottom">
          <div class="head">
              <div class="text">
                  {{'unit.support' | translate}}
              </div>
          </div>
              <div class="container">
                  <div class="inputBox">
                      <div class="label">
                          {{'unit.mobile' | translate}}
                      </div>
                      <div class="inputForm">
                          <input class="input" type="text" [(ngModel)]="mobile.support_no">
                          
                      </div>
                  </div>
                  <div class="submitButton" >
                      <div class="button" (click)="submitMobile();">
                        {{'unit.submit' | translate}}
                      </div>
                    </div>
                  <div class="inputBox">
                      <div class="label">
                          {{'unit.email' | translate}}
                      </div>
                      <div class="inputForm">
                          <input class="input" type="text" [(ngModel)]="email.support_email">
                          <div class="helpText">
                              {{'unit.seperatedByCommas' | translate}}
                            </div>
                      </div>
                  </div>
                  <div class="submitButton" >
                      <div class="button" (click)="submitEmail();">
                        {{'unit.submit' | translate}}
                      </div>
                    </div> -->
                  <!-- <div class="inputBox">
                      <div class="label">
                          Mobile
                      </div>
                      <div class="input">
                          <input class="input" type="text" placeholder="">
                      </div>
                  </div> -->
              <!-- </div>
          
  </div>

  <div class="leftBottom" style="height: 150px;">
      <div class="head">
          <div class="text">
              {{'unit.unitLabel' | translate}}
          </div>
      </div>
      <div class="container">
          <div class="inputBox">
              <div class="label">
                  {{'unit.logo' | translate}}
              </div>
              <div class="inputForm">
                  <input class="form-input" id="containerNo" accept="image/*, .pdf" (change)="fileChanged($event)" type="file" />
                  <span class="preview" *ngIf="this.logo" (click)="openLogoPreview()">
                      {{'unit.logo_preview' | translate}}
                    </span>
              </div>
          </div>
      </div>
  </div>
  <div class="leftBottom" style="height: 150px;">
      <div class="head">
          <div class="text">
              System Idle Timer (in mins)
          </div>
      </div>
      <div class="container">
          <div class="">
              <div class="inputForm">
                  <div class="label" style="font-size: 10px;">
                      Current Idle Time : {{this.idleTimer}} Mins
                  </div>
                      30 Mins <mat-slider
                        class="example-margin"
                        [max]="90"
                        [min]="30"
                        [step]="1"
                        [thumbLabel]="true"
                        (change)="changeIdleTimer()"
                        [tickInterval]="getSliderTickInterval()"
                        [(ngModel)]="idleTimer">
        
                    </mat-slider> 90 Mins
              </div>
          </div>
      </div>
  </div>
 
</div>
<div class="right">
  <div class="waybillSection">
      <div class="waybillHeader">
          <div class="label">
              {{'accountSettings.waybillSettings' | translate}}
          </div>
      </div>
      <div class="waybillBody">
        <div class="top">
          <div class="topLeft" *ngIf="!waybillSequence.custom_CWB_enabled">
              <div class="topLeftHeader">
                  <div class="label">
                    {{'accountSettings.defaultFormat' | translate}}
                  </div>
              </div>
              <div class="topLeftBody">
                  <div class="bodySection">
                      <div class="inputContainer">
                          <div class="label">
                            {{'accountSettings.waybill' | translate}}
                          </div>
                          <div class="input">
                              <input type="text" [disabled]="true" [(ngModel)]="lrSeq.lr_seq">
                          </div>
                      </div>
                  </div>
              </div>
          </div>
            <div [ngClass]="{'topRight':!waybillSequence.custom_CWB_enabled ,'topRight_custom':waybillSequence.custom_CWB_enabled }">
                <div class="topRightHeader">
                    <div class="label">
                      {{'accountSettings.customFormat' | translate}}
                    </div>
                </div>
                <div class="topRightBody">
                    <div class="bodySection">
                        <div class="inputContainer">
                            <div class="label">
                              {{'accountSettings.from' | translate}}
                            </div>
                            <div class="input">
                                <input type="number" [(ngModel)]="waybillSequence.custom_range.from">
                            </div>
                        </div>
                        <div class="inputContainer">
                            <div class="label">
                              {{'accountSettings.to' | translate}}
                            </div>
                            <div class="input">
                                <input type="number"  [(ngModel)]="waybillSequence.custom_range.to">
                            </div>
                        </div>
                        <div class="inputContainer">
                          <div class="label">
                            {{'accountSettings.customText' | translate}}
                          </div>
                          <div class="input">
                              <input type="text"  [(ngModel)]="waybillSequence.custom_text">
                          </div>
                      </div>
                        <div class="submitButton">
                            <div class="button" (click)="updateWaybillSeq();">
                              {{'accountSettings.submit' | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <div class="vehicle_types">
      <div class="leftBottom">
          <div class="head">
              <div class="text">
                  {{'unit.vehicle_types' | translate}}
              </div>
          </div>
              <div class="container">
                  <div class="inputBox">
                      <div class="label">
                          <mat-checkbox [(ngModel)]="checked" >{{'unit.changeVehicleType' | translate}}</mat-checkbox>
                      </div>
                      <div class="label">
                          {{'unit.vehicle_types' | translate}}
                      </div>
                      <div class="inputForm">
                          <mat-select multiple [(ngModel)]="preselectedvehicles" [disabled]="!checked">
                              <mat-option *ngFor="let vehicle of vehicles" (onSelectionChange)="selectvehicle(vehicle, $event)" [value]="vehicle._id">
                                {{vehicle.name}}
                              </mat-option>
                          </mat-select>
                      </div>
                  </div>
                  <div class="submitButton" >
                      <div  *ngIf="checked" class="button" (click)="submitVehicleTypes();">
                        {{'unit.submit' | translate}}
                      </div>
                      <div *ngIf="!checked" class="disabled">
                          {{'unit.submit' | translate}}
                        </div>
                    </div>
              </div>
      </div>
  </div>
</div>  --> 